import script from "./LocationModalView.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationModalView.vue?vue&type=script&setup=true&lang=js"

import "./LocationModalView.vue?vue&type=style&index=0&id=a9f0f418&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9f0f418"]])

export default __exports__